var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDangerAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M6.415,99H93.039c3.6,0,5.843-4.426,4.067-8L53.771,5.677a4.391,4.391,0,0,0-8.087,0L2.348,91c-1.776,3.573.467,8,4.067,8Zm48.01-16h-9.35V72.334h9.35ZM49.75,61.669c-2.571,0-4.675-2.4-4.675-5.333V45.671c0-2.933,2.1-5.333,4.675-5.333s4.675,2.4,4.675,5.333V56.337C54.425,59.269,52.322,61.669,49.75,61.669Z",
    transform: "translate(-1.727 -2.998)",
    fill: "#c50303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerAlert);
export default __webpack_public_path__ + "static/media/danger-alert.9c26bd2a13f039a9415c0b9ffe440aae.svg";
export { ForwardRef as ReactComponent };